import { render } from "./InputTreatmentDev.vue?vue&type=template&id=67994aec"
import script from "./InputTreatmentDev.vue?vue&type=script&lang=js"
export * from "./InputTreatmentDev.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__